export default __webpack_public_path__ + "static/media/frame.fb0bdad0.png";